export default __webpack_public_path__ + "static/media/claimsPageWhiteArrow.a3a9fa6d.svg";